import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const prefix = "far";
const iconName = "arrow-left";
const width = 448;
const height = 512;
const aliases: string[] = ["8592"];
const unicode = "f060";
const svgPathData =
    "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z";

const faArrowLeft: IconDefinition = {
    prefix: prefix,
    iconName: iconName,
    icon: [width, height, aliases, unicode, svgPathData],
};

export default faArrowLeft;
